import { render, staticRenderFns } from "./TiktokWebviewPage.vue?vue&type=template&id=892b4140&scoped=true&"
import script from "./TiktokWebviewPage.vue?vue&type=script&lang=js&"
export * from "./TiktokWebviewPage.vue?vue&type=script&lang=js&"
import style0 from "./TiktokWebviewPage.vue?vue&type=style&index=0&id=892b4140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892b4140",
  null
  
)

component.options.__file = "TiktokWebviewPage.vue"
export default component.exports